import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=5fe363d1&scoped=true&"
import script from "./activityPage.vue?vue&type=script&lang=js&"
export * from "./activityPage.vue?vue&type=script&lang=js&"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=5fe363d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe363d1",
  null
  
)

export default component.exports